import { ELogger } from './alk-logger.enum';
/** Class logger */
export class AlkLogger {
    constructor() {
        throw 'no instanciation allowed';
    }
    static debug(...args) {
        if (AlkLogger.getLogLevel() >= ELogger.DEBUG) {
            AlkLogger.getLogger().debug.apply(AlkLogger.getLogger(), [...args]);
        }
    }
    static info(...args) {
        if (AlkLogger.getLogLevel() >= ELogger.INFO) {
            AlkLogger.getLogger().info.apply(AlkLogger.getLogger(), [...args]);
        }
    }
    static warn(...args) {
        if (AlkLogger.getLogLevel() >= ELogger.WARN) {
            AlkLogger.getLogger().warn.apply(AlkLogger.getLogger(), [...args]);
        }
    }
    static error(...args) {
        if (AlkLogger.getLogLevel() >= ELogger.ERROR) {
            AlkLogger.getLogger().error.apply(AlkLogger.getLogger(), [...args]);
        }
    }
    /**
     * Logger to use
     */
    static setLogger(logger) {
        window['__logger__'] = logger;
    }
    static getLogger() {
        var _a;
        return (_a = window['__logger__']) !== null && _a !== void 0 ? _a : console;
    }
    /**
     * Log level priority
     * NONE > ERROR > WARN > INFO > DEBUG
     * for example, if log level is set to WARN, only warn and error are show
     * for instance the default lvl is INFO, so error, warn and info are show
     */
    static setLogLevel(logger) {
        window['__logLevel__'] = logger;
    }
    static getLogLevel() {
        var _a;
        return (_a = window['__logLevel__']) !== null && _a !== void 0 ? _a : ELogger.INFO;
    }
}
